import { GridValidRowModel } from '@mui/x-data-grid-pro';

import { QuoteStatusCell } from '../QuoteStatusCell/QuoteStatusCell';
import { TsrctSourcingCaseQuoteItemStatus } from '@/generated/gql/graphql';

export interface SourcingCaseQuoteStatusCellProps<R extends GridValidRowModel = any> {
  value: TsrctSourcingCaseQuoteItemStatus;
  row: R;
  viewOnly?: boolean;
  onStatusToggle?: (rowId: string | number, newStatus: TsrctSourcingCaseQuoteItemStatus) => void;
}

export const SourcingCaseQuoteStatusCell = <R extends GridValidRowModel = any>({
  value,
  row,
  viewOnly = true,
  onStatusToggle,
}: SourcingCaseQuoteStatusCellProps<R>) => (
  <QuoteStatusCell<R, TsrctSourcingCaseQuoteItemStatus>
    value={value}
    row={row}
    viewOnly={viewOnly}
    onStatusToggle={onStatusToggle}
    uncheckedValue={TsrctSourcingCaseQuoteItemStatus.NOT_REQUESTED}
    checkedValue={TsrctSourcingCaseQuoteItemStatus.REQUESTED}
  />
);
